/**
 * @component Ring
 * @description Kreisfoermiges Fortschrittsdiagramm (Donut/Ring-Chart).
 * Zeigt einen Prozentwert als animierten SVG-Ring mit optionalem Label.
 *
 * @prop {number}    [pct=0]        - Prozentwert (0-100)
 * @prop {string}    [color]        - Ringfarbe (Hex, Standard: Violet #338edc)
 * @prop {number}    [size=64]      - Groesse in Pixeln
 * @prop {number}    [stroke=5]     - Strichstaerke des Rings
 * @prop {string}    [label]        - Optionales Text-Label im Zentrum
 * @prop {ReactNode} [children]     - Optionaler Custom-Inhalt im Zentrum
 * @usage Verwendet auf Operations, Performance, Home fuer Auslastungsanzeigen
 */
export default function Ring({ pct = 0, color = '#338edc', size = 64, stroke = 5, label, children }) {
  const r = (size - stroke) / 2;
  const circ = 2 * Math.PI * r;
  const offset = circ - (pct / 100) * circ;

  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke="currentColor"
          strokeWidth={stroke}
          style={{ color: 'var(--ring-track)' }}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke={color}
          strokeWidth={stroke}
          strokeDasharray={circ}
          strokeDashoffset={offset}
          strokeLinecap="round"
          className="transition-all duration-700 ease-out"
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        {children || (
          <span className="font-mono font-bold text-xs" style={{ color }}>
            {label ?? `${Math.round(pct)}%`}
          </span>
        )}
      </div>
    </div>
  );
}
